export default {
    getChartOptions (id, categories, width=null) {
        let options = {
            chart: {
                id,
                toolbar: {
                    show: false
                },
                height: "300px"
            },
            xaxis: {
                categories,
                labels: {
                    show: true,
                    rotate: -45,
                    rotateAlways: true
                }
            },
            markers: {
                size: 5,
                shape: 'circle'
            }
        }

        if(width !== null){
            options.chart.width = '200%'
        }

        return options
    },
    getChartSeries (id, series) {
        return [{
            name: id,
            data: series
        }]
    }
}